var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('list-widget', {
    attrs: {
      "title": "추천인(뷰어) 코드",
      "max-width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var attrs = _ref.attrs;
        return [_c('autocomplete-viewer', _vm._b({
          attrs: {
            "item-text": _vm.itemText,
            "placeholder": "전체",
            "dense": "",
            "flat": "",
            "solo": "",
            "hide-details": "",
            "clearable": ""
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.query['_viewer'],
            callback: function callback($$v) {
              _vm.$set(_vm.query, '_viewer', $$v);
            },
            expression: "query['_viewer']"
          }
        }, 'autocomplete-viewer', attrs, false))];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }